import HalfScreenDialog from './halfScreenDialog';
import UI from './uiutil.for_iframe';
import ajaxCall from './ajaxcall';
import report11332 from '../report/11332_batch';
import * as Base from '../base/mbase';
import ActionSheet from './actionSheet';

var hasBindEvent = false;
var lastclicktime = 0;
function SubscribeMessage (options) {
    var self = this;
    this.insertStyle();
    this.appid = options.appid || 'wx62d9035fd4fd2059';
    this.type = options.type || 1;
    this.list = options.list || [];
    this.successCbk = options.success || function () {}
    this.uiarea = options.uiarea || 11704
    this.scene = options.scene || 117
    this.hideSuccessDialog = options.hideSuccessDialog || false
}

SubscribeMessage.prototype.update = function (options) {
    options = options || {}
    this.list = options.list || this.list
    this.appid = options.appid || this.appid
    this.type = options.type || this.type
    this.successCbk = options.successCbk || this.successCbk
    this.uiarea = options.uiarea || this.uiarea 
    this.scene = options.scene || this.scene
}

SubscribeMessage.prototype.check = function (id, cbk) {
    ajaxCall(
        '/cgi-bin/subscribe/getlistsubscribenew',
        JSON.stringify({
            method: 'POST',
            "page": 0,
            "page_size": 100,
            "appid": this.appid,
        }),
        function (res) {
            var hasSub = false;
            if(res && res.errcode === 0) {
                var list = res.subscribe_list || [];
                for(var i = 0, len = list.length; i < len; i++) {
                    if(id === list[i].id && list[i].status) {
                        hasSub = true;
                        break;
                    }
                }
            }
            cbk && cbk(hasSub);
        },
        function() {
            cbk && cbk()
        })
}

SubscribeMessage.prototype.click = function (cbk) {
    if(cbk) {
        var originCbk = this.successCbk;
        this.successCbk = function (res) {
            cbk && cbk(res);
            originCbk && originCbk(res);
        }
    }
    this.subscribe();
}

SubscribeMessage.prototype.cancel = function (data, cancelCbk) {
    var self = this;
    if(!data || !data.length) return;

    var width = document.documentElement.clientWidth;
    var textLength = width > 375 ? 8 : width > 359 ? 7 : 6
    var title = data[0].title || ''

    if(title.length > textLength) {
        title = title.substring(0, textLength) + '...'
    }
    
    ActionSheet.show({
        actionList: [
            `退订“${title}”后，你将不会收到相关消息`,
            '退订'
        ],
        actionCfgList: [{
            isTitle: true
        }, {
            isDanger: true
        }],
        clickCbk: (index) => {
            if(index === 1) {
                calcelEvent()

                self.report({
                    pid: 1,
                    aid: 91,
                    ext: JSON.stringify({
                        id: data[0].id
                    })
                })
            }
        },
        cancelCbk: () => {
        }
    })
    
    function calcelEvent() {
        var list = [];
        list.push({
            id: data[0].id,
            channel_id: data[0].channel_id,
        })

        UI.showLoading('退订中')

        ajaxCall(
            '/cgi-bin/subscribe/setsubscribenew',
            JSON.stringify({
                method: 'POST',
                "subscribe_list": list,
                "op_type": 1,
                "appid": self.appid,
            }),
            function(res) {
                if(res && res.errcode === 0) {
                    cancelCbk && cancelCbk(true)
                    UI.showLoading('退订成功', {
                        type: 'success',
                        timeout: 800
                    })
                }else {
                    UI.showLoading('退订失败', {
                        type: 'fail',
                        timeout: 800
                    })
                }
            }, function () {
                UI.showLoading('退订失败', {
                    type: 'fail',
                    timeout: 800
                })
            }
        )
    }
}

SubscribeMessage.prototype.subscribe = function () {
    var self = this;

    if(this.type === 1) {
        UI.showLoading('加载中')

        // 是否关注了公众号
        ajaxCall(
            '/cgi-bin/payattention',
            {
             j: JSON.stringify({
                "cmd": "batchhas", 
                "applist":["wx62d9035fd4fd2059"]
            }),
            },
            function(res){
                UI.hideLoading()
                // 关注了
                if(res && res.applist && res.applist[0]) {
                    if(res.applist[0].state === 1) {
                        self.report({
                            aid: 1,
                            op: 1,
                            ext: JSON.stringify({
                                source: 3
                            })
                        })
                        cbk();
                    }else {
                        // 没关注
                        self.report({
                            aid: 1,
                            op: 1,
                            ext: JSON.stringify({
                                source: 2
                            })
                        })
                        UI.alert('本订阅通过“微信游戏”官方公众号通知，继续订阅需要关注公众号', 
                            {
                                confirmTxt: '关注并订阅',
                                style: 'twoBtn',
                                confirmCb: function () {
                                    UI.showLoading('关注中')
                                    self.report({
                                        pid: 502,
                                        aid: 64,
                                    })
                                    ajaxCall(
                                        '/cgi-bin/payattention',
                                        {
                                         j: JSON.stringify({
                                            "cmd": "batchadd", 
                                            "applist":["wx62d9035fd4fd2059"]
                                        }),
                                        },
                                        function(res){
                                            UI.hideLoading()
                                            if(res && res.applist && res.applist[0] && res.applist[0].result) {
                                                cbk();
                                            }
                                        },
                                        function() {
                                            UI.hideLoading()
                                            UI.alert('网络错误，请稍后重试') 
                                        }
                                    )
                                },
                                closeCb: function () {
                                    self.report({
                                        pid: 502,
                                        aid: 61,
                                    })
                                }
                            }
                        )
                    }
                }else {
                    UI.hideLoading()
                    UI.alert('网络错误，请稍后重试') 
                }
            },
            function() {
                UI.hideLoading()
                UI.alert('网络错误，请稍后重试') 
            }
        )
    }else {
        self.report({
            aid: 1,
            op: 1,
            ext: JSON.stringify({
                source: 1
            })
        })
        cbk();
    }

    function cbk () {
        for(var i = 0, len = self.list.length; i < len; i++) {
            self.report({
                aid: 1,
                pid: i + 1,
                ext: JSON.stringify({
                    id: self.list[i].id
                })
            })
        }

        console.log(self.list);
        if(self.list.length === 1) {
            self.singleEvent();
        }else {
            self.muitiList();
        }
    }
}

SubscribeMessage.prototype.singleEvent = function () {
    var self = this;
    this.subscribeEvent();
}

SubscribeMessage.prototype.muitiList = function () {
    var self = this;

    new HalfScreenDialog(
        this.getHtml(),
        [{
            label: '取消',
            type: 'default',
            callback: function () {
                self.report({
                    pid: 1,
                    aid: 61,
                })
            }
        },
        {
            label: '订阅',
            type: 'primary',
            callback: function () {
                var doms = document.querySelectorAll('.global_subscribe-item') || [];
                var list = []
                for(var i = 0, len = doms.length; i < len; i++) {
                    if(self.list[i]) {
                        list.push({
                            id: self.list[i].id,
                            channel_id: self.list[i].channel_id,
                            checked: !!doms[i].querySelector('.global_subscribe-check-checked')
                        })
                    }
                }
                
                if(list.length) {
                    self.subscribeEvent(list)
                }
            }
        }]
    ) 

    setTimeout(function() {
        self.bindEvent();
        hasBindEvent = true;
    }, 100)
}

SubscribeMessage.prototype.subscribeEvent = function (data) {
    var self = this;
    var list = [];
    data = data || this.list;
    
    if(data.length === 1) {
        list.push({
            id: data[0].id,
            channel_id: data[0].channel_id,
        })
    }else {
        for(var i = 0, len = data.length; i < len; i++) {
            if(data[i].checked) {
                list.push({
                    id: data[i].id,
                    channel_id: data[i].channel_id,
                })
            }
        }
    }

    if(this.isLoading) return;

    if(!list.length) return;

    UI.showLoading('订阅中')
    ajaxCall(
        '/cgi-bin/subscribe/setsubscribenew',
        JSON.stringify({
            method: 'POST',
            "subscribe_list": list,
            "op_type": 0,
            "appid": this.appid,
        }),
        function(res) {
            
            if(res && res.errcode === 0) {
                if(Date.now() - lastclicktime < 300) return;
                
                if(data.length === 1) {
                    self.report({
                        pid: 1,
                        aid: 90,
                        ext: JSON.stringify({
                            id: data[0].id
                        })
                    })
                }else {
                    for(var i = 0, len = data.length; i < len; i++) {
                        if(data[i].checked) {
                            self.report({
                                pid: i + 1,
                                aid: 90,
                                ext: JSON.stringify({
                                    id: data[i].id
                                })
                            })
                        }
                    }
                }

                lastclicktime = Date.now();
                setTimeout(function() {
                    UI.hideLoading()
                    
                    if(self.hideSuccessDialog) return;
                    
                    new HalfScreenDialog(
                        self.getSubscribedHtml(self.type),
                        [{
                            label: '知道了',
                            type: 'default',
                            callback: function () {
                                self.report({
                                    pid: 503,
                                    aid: 2,
                                })
                            }
                        },
                        ]
                    ) 
                }, 400)

                self.successCbk(res);
                
            }else {
                UI.hideLoading()
                UI.alert('订阅失败，请稍后重试')
            }
        },
        function () {
            UI.hideLoading()
            UI.alert('订阅失败，请稍后重试')
        })

}

SubscribeMessage.prototype.report = function(obj) {
    var self = this;
    var map  = {
        scene   : 'iSceneId',
        uia     : 'iUIArea',
        pid     : 'iPositionId',
        ext     : 'sExternInfo',
        aid     : 'iActionId',
        op      : 'iOpType',
        gid     : 'sGameId',
        ssid    : 'iSourceSceneId',
        astsuts : 'sActionStatus'
    };

    var defaultRep = {
        gid     : self.appid,
        scene   : self.scene,
        uia     : self.uiarea,
        ssid    : self.ssid
    };

    var rep = Base.extend(defaultRep, obj);

    for ( var key in rep ) {
        if ( map[key] ) {
            rep[map[key]] = rep[key];

            delete rep[key];
        }
    }

    report11332([rep])
}

SubscribeMessage.prototype.bindEvent = function () {
    var self = this;
    var dom = document.querySelector('.global_subscribe-list');
    if(dom) {
        dom.addEventListener('click', function(e) {
            var item;
            var path = e.path;
            path = path || (e.composedPath && e.composedPath()) || []
            for(var i = 0, len = path.length; i < len; i++) {
                if(path[i].className === 'global_subscribe-item') {
                    item = path[i]
                    break;
                }
            }
            if(item) {
                var check = item.querySelector('.global_subscribe-check')
                if(check) {
                    check.classList.toggle('global_subscribe-check-checked')
                    if(check.className.indexOf('global_subscribe-check-checked') > -1) {
                        var id = +check.getAttribute('data-id');
                        var index = +check.getAttribute('data-index');
                        self.report({
                            pid: index + 1,
                            aid: 2,
                            ext: JSON.stringify({
                                id: id
                            })
                        })
                    }
                }
            }
        }, false)
    }
}

SubscribeMessage.prototype.insertStyle = function () {
    var dom = document.getElementById('global_subscribe_style');
    if(!dom) {
        var dom = document.createElement('style')
        dom.setAttribute('type', "text/css")
        dom.setAttribute('id', "global_subscribe_style")

        var style = `
            .global_subscribe-title {padding: 10px 24px 22px; font-size: 15px; font-weight: 600; color: rgba(0, 0, 0, 0.9)}
            .global_subscribe-list {padding: 0 24px; position: relative;cursor:pointer;}
            .global_subscribe-list:before { content: '';position: absolute; left: 24px; right: 24px; top: 0; transform: scaleY(.5);border-top: 1px solid rgba(0, 0, 0, 0.1)}
            .global_subscribe-list:after { content: '';position: absolute; left: 24px; right: 24px; bottom: 0; transform: scaleY(.5);border-top: 1px solid rgba(0, 0, 0, 0.1)}
            .global_subscribe-item {padding: 16px 0 16px 36px;font-size: 17px;line-height: 24x;color: rgba(0, 0, 0, 0.9);position: relative}
            .global_subscribe-item:after {content: '';position: absolute; left: 36px; right: 0; bottom: 0; transform: scaleY(.5);border-top: 1px solid rgba(0, 0, 0, 0.1)}
            .global_subscribe-item:last-child::after {display: none}
            .global_subscribe-desc { color: rgba(0, 0, 0, 0.3); font-size: 14px;line-height: 20px;}
            .global_subscribe-check {position: absolute; left: 0; width: 24px; height: 24px;top: 50%; margin-top: -12.5px; border: 1px solid rgba(0, 0, 0, 0.3);border-radius: 100%;}
            .global_subscribe-check-checked {border: 1px solid rgba(0, 0, 0, 0);transform: scale(1.22); background-position: center; background-size: 24px 24px; background-repeat: no-repeat;background-image: url(https://res.wx.qq.com/wechatgame/product/cdn/moment/icon-fill-done_9ca3b830_72addbfc.svg)}
            .global_subscribe_success-title {padding-top: 28px;font-size: 17px; line-height: 24px;font-weight: 600; color: rgba(0, 0, 0, 0.9);text-align: center;}
            .global_subscribe_success-desc {padding-top: 8px;font-size: 14px; line-height: 20px; color: rgba(0, 0, 0, 0.9);text-align: center;}
            .global_subscribe_success-pic {width:194px; height: 242px; margin: 24px auto 0; background-position: center;background-repeat: no-repeat; background-size: 100%; text-align: center;}
            .global_subscribe_success-pic-entry {width: 194px; height: 282px;}
            .wg_dark_mode .global_subscribe-title{color: rgba(255,255,255,0.8)}
            .wg_dark_mode .global_subscribe-item{color: rgba(255,255,255,0.8)}
            .wg_dark_mode .global_subscribe_success-title{color: rgba(255,255,255,0.8)}
            .wg_dark_mode .global_subscribe_success-desc{color: rgba(255,255,255,0.8)}
            .wg_dark_mode .global_subscribe-desc {color: rgba(255,255,255,0.3);}
            .wg_dark_mode .global_subscribe-check {border: 1px solid rgba(255, 255, 255, 0.3);}
            .wg_dark_mode .global_subscribe-check-checked {border: none;}
            .wg_dark_mode .global_subscribe-list:before{border-top: 1px solid rgba(255, 255, 255, 0.05)}
            .wg_dark_mode .global_subscribe-list:after{border-top: 1px solid rgba(255, 255, 255, 0.05)}
            .wg_dark_mode .global_subscribe-item:after{border-top: 1px solid rgba(255, 255, 255, 0.05)}
        `

        dom.innerHTML = style
        var head = document.getElementsByTagName('head')[0]
        head.appendChild(dom)
    }
}

SubscribeMessage.prototype.getHtml = function () {
    var list = this.list || [];

    var items = ``

    for(var i = 0, len = list.length; i < len; i++) {
        items +=  `
            <div class="global_subscribe-item">
                <div>${list[i].title || ''}</div>
                <div class="global_subscribe-desc">${list[i].desc || ''}</div>
                <div class="global_subscribe-check global_subscribe-check-checked" data-id="${list[i].id}" data-index="${i}"></div>
            </div>
        `
    }
    var html = `
        <div class="global_subscribe-title">请选择要订阅的内容</div>
        <div class="global_subscribe-list">
            ${items}
        </div>
    `

    return html
}

SubscribeMessage.prototype.getSubscribedHtml = function (type) { 
    var isDarkMode = document.querySelector('.wg_dark_mode');
    return `
        <div class="global_subscribe_success-title">订阅成功</div>
        <div class="global_subscribe_success-desc">${type === 1 ? '有新消息会通过“微信游戏”公众号通知你' : '有新消息会通过“发现/游戏”通知你'}</div>
        <div class="global_subscribe_success-pic ${type === 1 ? '' : 'global_subscribe_success-pic-entry'}" style="background-image: url(${
            isDarkMode ? 
                (type === 1 ? 'https://res.wx.qq.com/wechatgame/product/cdn/moment/7fab0af8.png' : 'https://res.wx.qq.com/wechatgame/product/cdn/moment/f4957b8d.png')
                : (type === 1 ? 'https://res.wx.qq.com/wechatgame/product/cdn/moment/198d3ac3.png' : 'https://res.wx.qq.com/wechatgame/product/cdn/moment/249dabd7.png')})"></div>
    `
}

export default SubscribeMessage;